import {h, Fragment} from "preact"
import { useAppState, useConfig, InfiniteScroll } from "@nosto/preact"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import Loader from "./elements/Loader"
import { useEffect, useState } from "preact/hooks"

export default function Category() {
  const [foundProducts, setFoundProducts] = useState(false);
  const [stateLoading, setStateLoading] = useState(true);
  const [primaryFirst, setPrimaryFirst] = useState(true);
  const [hoverImageFirst, setHoverImageFirst] = useState(false);
  const [salesBoost, setSalesBoost] = useState(false);
  const { categoryCssSelector } = useConfig();

  const {
    response: { products },
    loading
  } = useAppState();

  useEffect(() => {
    setFoundProducts(products && products.total > 0);
    setStateLoading(loading);

    if (document.querySelector(categoryCssSelector)) {
      setPrimaryFirst(document.querySelector(categoryCssSelector).getAttribute('data-ignore-primary') === 'false');
      setSalesBoost(document.querySelector(categoryCssSelector).getAttribute('data-boost-sales') === 'true');
      setHoverImageFirst(document.querySelector(categoryCssSelector).getAttribute('data-hover-image-first') === 'true');
    }
  }, [loading]);

  return (
    <div class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-p-4 ns-my-0 ns-mx-auto">
      {foundProducts && (
        <>
          <Sidebar toggleId={'toggle_button'} />
          {/* <Toolbar labelFor={'toggle_button'} /> */}
        </>
      )}
      <div class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0 ns-pl-md-5">
        {/* {foundProducts && !stateLoading ? (
          <>
            <SelectedFilters />
            <Toolbar lableFor={'toggle_button'} />
            <Products primaryFirst={primaryFirst} salesBoost={salesBoost} />
            <BottomToolbar />
          </>
        ) : stateLoading ? (
          <Loader />
        ) : (
          <NoResults />
        )} */}

        {/* To enable InfiniteScroll - comment above block and uncomment below.
                    Don't forget to import InfiniteScroll component. */}
        {foundProducts ? (
            <>
                <SelectedFilters />
                <Toolbar lableFor={'toggle_button'}/>
                <InfiniteScroll>
                    <Products primaryFirst={primaryFirst} salesBoost={salesBoost} hoverImageFirst={hoverImageFirst}/>
                </InfiniteScroll>
            </>
        ) : loading ? (
            <Loader />
        ) : (
            <NoResults />
        )}
      </div>
    </div>
  )
}